// The scene behind the application: laser haze in drifting fog, and a frond
// hanging into each of the top two corners.
//
// The corners are photographs recolored per theme in CSS rather than per file,
// so a theme change costs nothing and no palette needs its own asset.

export function AmbientArt() {
  return (
    <div className="artlayer" aria-hidden="true">
      <div className="fog a" />
      <div className="fog b" />
      <div className="beams" />
      <div className="corner left" />
      <div className="corner right" />
    </div>
  );
}

